<template>
  <div
    class="relative"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <contact-avatar
      :contact="contact"
      :name="room.name"
      :is-own="isMyOwn"
      :is-room="room.isGroup"
      :room="room"
    />
    <div
      data-test="remove"
      class="
        absolute right-0 top-0 flex h-[14px] w-[14px] cursor-pointer items-center
        justify-center rounded-full border border-white bg-primary
      "
      @click="emit('remove', room.pServedUser)"
    >
      <wui-icon
        name="clear"
        class="h-2! w-2! text-white"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { WuiIcon } from '@wui/common-library'
import { ref, computed } from 'vue'

import { useStoreContacts } from '@/entities/contact'
import { ContactAvatar } from '@/entities/contact-avatar'

import { useCurrentUser } from '@/shared/composables/current-user'
import { Room } from '@/shared/types/store'

const props = defineProps<{
  room: Room
}>()

const emit = defineEmits<{
  (event: 'remove', id: string): void;
}>()

const isHovered = ref(false)

const { currentUser } = useCurrentUser()

const { findByPServed } = useStoreContacts()

const contact = computed(() => findByPServed(props.room.pServedUser))

const isMyOwn = computed(() => {
  return props.room.id === currentUser.value?.imLogin
})
</script>
